import React, { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { database } from "../firebaseConfig";
import ChanceRadarEditor from "./ChanceRadarEditor";

/**
 * Saved Chance Radars. Each one is a research setup, not an email image.
 * A template can attach one to every variant, or an agent can run it as a step.
 */
const ChanceRadarSettings = ({ userId }) => {
  const [radars, setRadars] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    if (!userId) return undefined;
    return onValue(ref(database, `/World/${userId}/settings/chanceRadars`), (snap) => {
      const node = snap.exists() ? snap.val() : null;
      const list = node && typeof node === "object"
        ? Object.entries(node).map(([id, value]) => ({ id, ...value }))
        : [];
      list.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
      setRadars(list);
    });
  }, [userId]);

  if (creating || editingId) {
    return (
      <ChanceRadarEditor
        userId={userId}
        assetId={editingId}
        assets={radars}
        onExit={() => {
          setCreating(false);
          setEditingId(null);
        }}
      />
    );
  }

  return (
    <div className="il wr">
      <div className="il-editorBar">
        <span className="il-editorTitle">Chance Radar</span>
      </div>
      <section className="wr-step">
        <div className="wr-stepHead">
          <span className="wr-stepNum">1</span>
          <div>
            <h3 className="wr-stepTitle">Live chances for their market</h3>
            <p className="wr-stepSub">
              A cheaper Google search finds named companies with a recent signal. It can include a weak hit, so the email only uses what clearly fits. The result is text in the email context, for every variant of a template or as a step in an agent.
            </p>
          </div>
        </div>
        <div className="cr-actions">
          <button type="button" className="altBtn altBtn--petrol" onClick={() => setCreating(true)}>
            New Chance Radar
          </button>
        </div>
        <div className="cr-templates" style={{ marginTop: 16 }}>
          {radars.map((radar) => (
            <button type="button" key={radar.id} className="cr-template" onClick={() => setEditingId(radar.id)}>
              <b>{radar.name || radar.topic || "Chance Radar"}</b>
              <span>{radar.topic || radar.hunt}</span>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ChanceRadarSettings;

export function useChanceRadars(userId) {
  const [radars, setRadars] = useState([]);
  useEffect(() => {
    if (!userId) return undefined;
    return onValue(ref(database, `/World/${userId}/settings/chanceRadars`), (snap) => {
      const node = snap.exists() ? snap.val() : null;
      const list = node && typeof node === "object"
        ? Object.entries(node).map(([id, value]) => ({ id, ...value }))
        : [];
      list.sort((a, b) => (b.updatedAt || 0) - (a.updatedAt || 0));
      setRadars(list);
    });
  }, [userId]);
  return radars;
}

export function ChanceRadarTemplateField({ userId, value, onChange }) {
  const radars = useChanceRadars(userId);
  return (
    <div className="ed-gi-field">
      <label className="ed-gi-label">
        <i className="fa fa-satellite-dish"></i>
        <span>Chance Radar</span>
        <span className="ed-gi-hint">Runs for every variant. The findings are text in the email context. The cheaper search can include a weak hit.</span>
      </label>
      <select value={value || ""} onChange={(event) => onChange(event.target.value)}>
        <option value="">Off</option>
        {radars.map((radar) => (
          <option key={radar.id} value={radar.id}>{radar.name || radar.topic || "Chance Radar"}</option>
        ))}
      </select>
    </div>
  );
}
